// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2024 Vic Zhu <viczhu2014@gmail.com>

import {
  Datagrid,
  DateField,
  FunctionField,
  NumberField,
  TextField,
  useStore,
  useTranslate,
} from 'react-admin'
import { applyDLSBGMCorrection, formatGlucoseForDisplay } from '../common'

const MetricDatagrid = ({ rowClick = 'edit' }) => {
  const translate = useTranslate()
  const [glucoseUnit] = useStore('glucoseUnit', 'mmol/L')
  return (
    <Datagrid rowClick={rowClick} bulkActionButtons={false}>
      <FunctionField
        label={translate('resources.metrics.fields.device')}
        render={(record) => record.device?.name}
      />
      <TextField source="offset" />
      <FunctionField
        label={translate('resources.metrics.fields.timestamp')}
        render={(record) => new Date(record.timestamp * 1000).toLocaleString()}
      />
      {/* The raw column is deliberate: this list is the support-facing view of
          the STORED (QR) value — see the en.ts label comment. The display
          column beside it is what the vet sees everywhere else (and what this
          list's own CSV exports): BGM-corrected, out-of-range-masked, in the
          active display unit. Without it a stored 14.2 on this screen and the
          12.1 on the chart read as two different readings.
          Two decimals: the stored float printed as 102.99500249940485. */}
      <NumberField source="glucose" options={{ maximumFractionDigits: 2 }} />
      <FunctionField
        source="glucose"
        label={translate('resources.metrics.fields.glucose_display')}
        sortable={false}
        render={(record) =>
          typeof record.glucose === 'number'
            ? formatGlucoseForDisplay(applyDLSBGMCorrection(record.glucose), glucoseUnit)
            : null
        }
      />
      <DateField source="createdAt" label={translate('resources.metrics.fields.createdAt')} />
      <DateField source="updatedAt" label={translate('resources.metrics.fields.updatedAt')} />
    </Datagrid>
  )
}

export default MetricDatagrid
